console.log("init Proteus treatments -- v1.04");

// set default checkout upsell
if(!window.sessionStorage.getItem("Proteus Checkout Upsell")){
  window.sessionStorage.setItem("Proteus Checkout Upsell", "default-upsell");
  gtm_add_cartAttribute("proteus_checkout_upsell_visibility", "default-upsell");
}

function checkVariantAndTogglePrice() {
  const urlParams = new URLSearchParams(window.location.search);
  const currentVariant = urlParams.get('variant');
  const isFirewoodPage = window.location.pathname.includes('/products/firewood');
  const shouldShowPrice = isFirewoodPage && currentVariant === '43338487693357';
  
  // Remove existing style if it exists
  const existingStyle = document.getElementById('price-toggle-style');
  if (existingStyle) {
    existingStyle.remove();
  }
  
  if (!shouldShowPrice) {
    document.querySelector('body').insertAdjacentHTML("afterbegin", `
      <style id="price-toggle-style">
      .product-info__price{
        display: none;
      }
      </style>  
    `);
  }
}

waitForElement('.shopify_subscriptions_app_container').then(subscription_app => {
  // Initial check
  checkVariantAndTogglePrice();
  
  // Listen for variant changes
  document.addEventListener('variant:change', checkVariantAndTogglePrice);
  
  // Also listen for URL changes (pushstate/popstate)
  window.addEventListener('popstate', checkVariantAndTogglePrice);
  
}).catch();
// support for [BRE-09] PP upsells

/* 
LIDS (prod id: 6578299830317)  
const x19_lid: 39397496324141
const x24_lid: 39397502484525
const x30_lid: 39397505990701

PITS (prod_id: 7219796508717)
X19 / Corten: 41234257870893
X19 / Stainless: 41234257903661
X24 / Corten: 41234325700653
X24 / Stainless: 41234325733421
X30 / Corten: 41234325766189
X30 / Stainless: 41234325798957
X42 / Corten: 41860588306477
X42 / Stainless: 4186059574481
*/

// mapping PIT variant IDs → their matching LID
// Map PIT variant IDs → corresponding LID (product + variant)
const pit_lid_map = {
  // X19 pits
  41234257870893: { prod: 6578299830317, var: 39397496324141 },
  41234257903661: { prod: 6578299830317, var: 39397496324141 },

  // X24 pits
  41234325700653: { prod: 6578299830317, var: 39397502484525 },
  41234325733421: { prod: 6578299830317, var: 39397502484525 },

  // X30 pits
  41234325766189: { prod: 6578299830317, var: 39397505990701 },
  41234325798957: { prod: 6578299830317, var: 39397505990701 },

  // X42 pits: add mapping when you have the LID(s)
  // 41860588306477: { prod: 6578299830317, var: ??? },
  // 4186059574481: { prod: 6578299830317, var: ??? },
};

document.addEventListener("cart:change", async (event) => {
  window.cart_data = event.detail.cart;

  const lids_to_add = new Set();
  const prods_to_add = new Set();

  for (const item of window.cart_data.items) {
    const match = pit_lid_map[item.variant_id];
    if (match) {
      lids_to_add.add(String(match.var));
      prods_to_add.add(String(match.prod));
    }
  }

  // Build CSV strings; if no matches, set to "none"
  const pp_var_ids  = lids_to_add.size ? Array.from(lids_to_add).join(",") : "none";
  const pp_prod_ids = prods_to_add.size ? Array.from(prods_to_add).join(",") : "none";

  // Desired attributes payload (strings only)
  const desiredAttrs = {
    pp_multi_offer: "true",
    pp_var_ids,
    pp_prod_ids,
    pp_coll_ids: "none",
    pp_discount_amount: "10",
    pp_discount_type: "percentage",
  };

  // (Optional) Skip network call if nothing changes
  const curr = window.cart_data.attributes || {};
  const unchanged =
    curr.pp_multi_offer === desiredAttrs.pp_multi_offer &&
    curr.pp_var_ids === desiredAttrs.pp_var_ids &&
    curr.pp_prod_ids === desiredAttrs.pp_prod_ids &&
    curr.pp_coll_ids === desiredAttrs.pp_coll_ids &&
    curr.pp_discount_amount === desiredAttrs.pp_discount_amount &&
    curr.pp_discount_type === desiredAttrs.pp_discount_type;

  if (unchanged) return;

  try {
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ attributes: desiredAttrs }),
    });
    const data = await res.json();
    console.log("Cart attributes updated:", data?.attributes ?? data);
  } catch (err) {
    console.error("Error updating cart:", err);
  }
});


if(getParam("cart") == "open"){
  waitForElement('[aria-controls="cart-drawer"]').then(cart_trigger => {
    cart_trigger.click();
  }).catch()
}

/* START support for [BRE-01] */
let free_burger_press = () => {
  
  window.sessionStorage.setItem("[BRE-01] activate Burger Press GWP", true);
  let burger_press_var_id = 42490257834029;

  // logic for all NOT /cart pages
  let assess_cart = (cart_total) => {

    waitUntil(() => {
      return typeof window.cart_data != "undefined" && typeof window.cart_data.items != "undefined";
    }).then(() => {

      let burger_press_in_cart = window.cart_data.items.some(item => item.title.toLowerCase().includes('breeo burger press'));
      if(!burger_press_in_cart && window.cart_data.total_price >= 39800 && !window.sessionStorage.getItem("[BRE-01] Burger Press GWP added")){
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: burger_press_var_id, 
              quantity: 1
            }]
          })
        }).then(response => response.json()).then(cart => {
          console.log("assess_cart item added"),
          window.sessionStorage.setItem("[BRE-01] Burger Press GWP added", true);
          window.location.href = `/discount/FREEPRESS?redirect=${window.location.pathname}?cart=open`;
        }).catch(error => {
          console.error('Error adding item to cart:', error);
        });
        
      }
      
    }).catch();
    
  };

  // init
  assess_cart();

  document.addEventListener('rebuy:cart.change', (event) => { 
    assess_cart(event.detail.cart.subtotal()); 
  });

  document.addEventListener('rebuy:cart.ready', (event) => { 
    // assess_cart(event.detail.cart.subtotal());
  });
  
};

if(window.sessionStorage.getItem("[BRE-01] activate Burger Press GWP") ||
  getParam("free_burger_press") ||
  getParam("utm_campaign").toLowerCase().indexOf("burger press") > -1){
  free_burger_press();
}

window.addEventListener("klaviyoForms", function(e) { 
  console.log("klaviyoForms event", e.detail)
  if (e.detail.type == 'submit' && e.detail.formId == "W2VaPf") {
    free_burger_press();
  }
});
/* END support for [BRE-01] */

/* START support for [BRE-23] */
let activation_param = "pt=firestarter";

const add_item_to_cart = (var_id) =>{
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            items: [
            {
                id: var_id,
                quantity: 1,
                properties: {
                    source: "email signup",
                    _discount: "email signup",
                }
            }
            ]
        })
    }).then(res => res.json()).then(data => {
    console.log('Added to cart:', data);
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    }).catch(err => console.error('Error adding to cart:', err));
}

if(window.sessionStorage.getItem("[BRE-23] in-cart treatment") || window.location.href.indexOf(activation_param) > -1){
    window.sessionStorage.setItem("[BRE-23] in-cart treatment", true);

    

      let review_cart = () => {

        waitForElement('.cart-drawer__line-items').then(cart => {

          let cart_items = cart.querySelectorAll('line-item');
          let show_gwp = false;
          for(let i = 0; i < cart_items.length; i++){
              if(cart_items.length > 0){
                  show_gwp = true;
              }
              if(cart_items[i].innerText.indexOf("source: email signup") > -1){
                  show_gwp = false;
                  break;
              }
          }

          if(show_gwp){
              // an item is in the cart AND not the offer
              console.log("setting it up")
              
              if(document.querySelectorAll('.js-offer').length == 0){
                  cart.insertAdjacentHTML("beforebegin", `
                      <style>
                      .js-offer{
                          background: #e6e4db;
                          margin: 1rem 0;
                          padding: 1rem 1rem 1rem 0;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                      }
                      .js-offer > div:first-child{
                          padding-left: 100px;
                          background: url(https://breeo.com/cdn/shop/files/firestarters-main.png?v=1747254340&width=300) left center no-repeat;
                          background-size: 100px;
                      }
                      .js-offer > div:last-child{
                          text-align: center;
                      }
                      .js-offer > div:last-child span{
                          display: block;
                          font-size: .75rem;
                          margin-top: -.5rem;
                      }
                      .js-offer #gwp-atc{
                          transform: scale(.75)
                      }
                      .button.button--xs{
                        cursor: pointer;
                      }
                      @media(max-width: 525px){
                          .js-offer{
                              display: block;
                          }
                          .js-offer > div:last-child{
                              text-align: left;
                              margin-left: 75px;
                          }        
                          .js-offer #gwp-atc{
                              margin-left: 0;
                          }   
                          .js-offer > div:last-child span{
                              margin-left: 55px;
                          }
                      }
                      </style>
                      <div class="js-offer">
                          <div>
                              Claim your <strong>FREE</strong> Waterproof Fire Starters
                          </div>
                          <div style="min-width: 190px;">
                              <div id="gwp-atc" class="button button--xs">Add to Cart</div>
                              <span>a $20.00 value</span>
                          </div>
                          
                      </div>
                  `)
              }
          } else {
              console.log("tearing it down")
              if(document.querySelectorAll('.js-offer') > 0){
                  document.querySelector('.js-offer').remove();
              }
          }

        }).catch();

      } // review_cart();

      // init
      setTimeout(() => {
          review_cart();
      }, 1500)

      observeSelector('line-item', line_item => {
          review_cart();
      });

      observeSelector('#gwp-atc', gwp_atc => {
          gwp_atc.addEventListener("click", (e) => {
              add_item_to_cart(41451417763885); // firestarters
              gwp_atc.parentNode.style.opacity = 0.5;
              setTimeout(() => {
                  gwp_atc.parentNode.remove();
              }, 750)
          });
      });

    // if activated, BLOCK the popups

    const og_form_id_desktop = "W2VaPf";
    const new_form_id_desktop = "SQYvmN";
    const alt_form_id_desktop = "UmvBFA";

    const select_topmost_ancestor = (element, selector) => {
        if (!element) {
        return null;
        }
    
        // Check if the current element matches the specified selector
        if (!element.closest(selector)) {
        // If it does not match, return the current element
        return element;
        }
    
        // Otherwise, check its parent element recursively
        return select_topmost_ancestor(element.parentElement, selector);
    };

    observeSelector(`form[data-testid="klaviyo-form-${og_form_id_desktop}"], form[data-testid="klaviyo-form-${new_form_id_desktop}"], form[data-testid="klaviyo-form-${alt_form_id_desktop}"]`, kl_form => {
        let popup_container = select_topmost_ancestor(kl_form, '.needsclick[class*="kl-"]')
        popup_container.remove();
        document.body.classList.remove("klaviyo-prevent-body-scrolling");
        setTimeout(() => {
            document.body.classList.remove("klaviyo-prevent-body-scrolling");
        }, 500)
    })

}
/* END support for [BRE-23] */